<!-- <div nz-row nzType="flex">
  <div nz-col nzSpan="24" style="display: flex; justify-content: flex-end;">
    <form nz-form [nzLayout]="'inline'">
      <nz-form-item>
        <nz-form-control>
          <nz-select style="width: 250px;" name="category" nzShowSearch nzAllowClear nzPlaceHolder="Select a Category"
            [(ngModel)]="TASK_CATEGORY_ID" (ngModelChange)="onCategoryChange()">
            <nz-option *ngFor="let category of categoryList" [nzValue]="category.ID" [nzLabel]="category.NAME">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <input type="text" name="search" nz-input placeholder="Search Records" [(ngModel)]="searchText" />
      </nz-form-item>
    </form>
  </div>
</div> -->

<div nz-row>
  <div nz-col nzSpan="24">
    <nz-table class="my-scroll no-wrap1" [nzScroll]="{ x: '1000px' }" nzBordered #table [nzLoading]="loadingRecords"
      [nzFrontPagination]="false" [nzData]="mappingData">

      <thead>
        <tr>
          <th>Name</th>
          <th>Category</th>
          <th>Role</th>
          <th>Is Assign</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let data of table.data | filter:searchText">
          <td>{{data.NAME}}</td>
          <td>{{data.TASK_CATEGORY_NAME}}</td>
          <td>
            <nz-select name="role_name" style="width: 100%;" nzShowSearch [(ngModel)]="data.ROLE_ID">
              <nz-option *ngFor="let role of roles" [nzValue]="role.ID" [nzLabel]="role.NAME"></nz-option>
            </nz-select>
          </td>
          <td>
            <nz-switch name="is_active" nzCheckedChildren="Y" nzUnCheckedChildren="N" [(ngModel)]="data.IS_ACTIVE">
            </nz-switch>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>

<div class="footer">
  <button type="button" nz-button (click)="close()" class="ant-btn"
    style="margin-right: 8px;"><span>Cancel</span></button>
  <button type="button" class="ant-btn ant-btn-primary" nz-button nz-dropdown [nzDropdownMenu]="menu"
    [nzLoading]="isSpinning" (click)="save(false)"><span>Save &
      Close</span></button>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
        <a (click)="save(true)">Save & New</a>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>